module.exports = __webpack_public_path__ + "static/media/icFollowers.d47a6c3f.svg";